import React, { useState, useEffect, useRef } from 'react'
import { ConsolidationWarningModal } from '../../components/ConsolidationWarning';
import { useNavigate, useParams } from 'react-router-dom'
import {
    StdtInfo,
    getIstQuarter,
    getIIndQuarter,
    getIIIrdQuarter,
    getIVthQuarter,
    getVthQuarter,
    getVIthQuarter,
    updateStatus,
    getSchoolYear,
    GetNumGrade,
    createHistoryGrade,
    GetMatter,
    DestroyNumericalGrade,
    updateNumericalGrade,
    clssInfo,
    getAssessmentRegime,
    createResponsible,
    getResponsiblesByStudent,
    findResponsibleByCpf,
    linkResponsibleToStudent,
    updateResponsible
} from '../../Api'
//import Calendar from '../../components/CalendarUI/Calendar'

import {
    Container,
    Emp,
    Span,
    ContainerDivs,
    Pro,
    ProfilePhoto,
    ProfileInfo,
    EmployeeInfo,
    DivButtomEdit,
    Btt02,
    Btt01,
    Button,
    WarningBox,
    Input,
    Label,
    Select,
    ErrorMessage,
    //ContainerCalendar,
    TableRow,
    Chip,
    ModalOverlay,
    ModalContent,
    HistoricGradeContainer,
    HistoricGradeRow,
    HistoricModalContent,
    HistoricModalOverlay,
    EmptyHistoricMessage,
    AddHistoricButton,
    ModalActions,
    ButtonSecondary,
    BlurBackground,
    ModalContainer,
    EditContainer,
    EmpEdit,
    Grade,
    EditOverlay,
    HeaderRow,
    DivTopActions,
    SchoolDivider,
    SectionLabel,
    SkeletonHero,
    SkeletonCard,
    SkeletonLine,
    DetailGrid,
    DetailItem,
    EmpName,
    ClassChips,
    ClassTitle,
    RespForm,
    RespFormRow,
    RespList,
    RespCard,
    RespExistCard,
    RespExistRow,
    CpfStatus,
    RespCardHead,
    RespCardBody,
    RespDataPill,
    RespEditBtn,
    RespAvatar,
} from './style';

// gráfico de desempenho do aluno (mesma seção usada no dashboard do responsável)
import PerformanceSection from '../../components/ModalDesempenho'

/* iniciais para o avatar */
const initials = (name = '') =>
    name.trim().split(/\s+/).slice(0, 2).map(n => n[0] || '').join('') || '?';

/* data segura (evita "Invalid Date") */
const fmtDate = (d) => {
    if (!d) return '';
    const parsed = new Date(d + "T00:00:00");
    return isNaN(parsed) ? '' : parsed.toLocaleDateString('pt-BR');
};

const Student = () => {

    const navigate = useNavigate()
    const [assessmentFormat, setassessmentFormat] = useState('');
    const [I, setI] = useState([])
    const [II, setII] = useState([])
    const [III, setIII] = useState([])
    const [IV, setIV] = useState([])
    const [V, setV] = useState([])
    const [VI, setVI] = useState([])
    const [Clss, setClss] = useState([])
    const [student, setStudent] = useState([])
    const [Selectbimonthly, setSelectbimonthly] = useState([])
    const [bimonthly, setbimonthly] = useState([])
    const [, setRegent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [removeStudent, setRemoveStudent] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageHistoric, setErrorMessageHistoric] = useState('');

    const [positionAtSchool, setPositionAtSchool] = useState('');
    const [positionAtEducationDepartment, setPositionAtEducationDepartment] = useState('')

    const [selectedStatus, setSelectedStatus] = useState({});
    const [exitDate, setExitDate] = useState(null);

    const [selectedBimId, setSelectedBimId] = useState("");      // guarda o _id
    const [selectedBimName, setSelectedBimName] = useState("");  // guarda o nome do bimestre

    const [openNoClassModal, setOpenNoClassModal] = useState(false);
    const [openNoPeriodModal, setOpenNoPeriodModal] = useState(false);

    const [resHistoricGrade, setresHistoricGrade] = useState()
    const [openHistoricModal, setOpenHistoricModal] = useState(false);
    const [openAddHistoric, setOpenAddHistoric] = useState(false);

    const [matter, setMatter] = useState([])
    const [Selectmatter, setSelectMatter] = useState([])
    const [$schoolYea, set$schoolYea] = useState()
    const [historicGrade, setHistoricGrade] = useState()
    const [SelectbihistoricGrades, setSelectbihistoricGrades] = useState([])
    const [open, setopen] = useState(null)

    const [confirmModal, setConfirmModal] = useState(false);
    const [selectedGrade, setSelectedGrade] = useState(null);
    const [update_studentGrade, setUpdateStudentGrade] = useState(null);

    const [update_id_grade, setUpdateIdGrade] = useState(null);

    const [assessmentRegime, setAssessmentRegime] = useState('');

    // ── Responsável ──
    const [openRespModal, setOpenRespModal] = useState(false);
    const [openRespListModal, setOpenRespListModal] = useState(false);
    const [respList, setRespList] = useState([]);
    const [loadingRespList, setLoadingRespList] = useState(false);
    const [savingResp, setSavingResp] = useState(false);
    const [respError, setRespError] = useState('');
    const [respForm, setRespForm] = useState({
        name: '',
        cpf: '',
        rg: '',
        cellPhone: '',
        email: '',
        kinship: '',
        password: '',
    });

    // verificação de CPF enquanto digita
    const [cpfChecking, setCpfChecking] = useState(false);
    const [existingResp, setExistingResp] = useState(null);
    const [respAlreadyLinked, setRespAlreadyLinked] = useState(false);
    const [openRespExistModal, setOpenRespExistModal] = useState(false);
    const [linkingResp, setLinkingResp] = useState(false);
    const cpfReqId = useRef(0);

    // edição de responsável
    const [openRespEditModal, setOpenRespEditModal] = useState(false);
    const [editingRespId, setEditingRespId] = useState(null);
    const [savingRespEdit, setSavingRespEdit] = useState(false);
    const [respEditError, setRespEditError] = useState('');
    const [respEditForm, setRespEditForm] = useState({
        name: '',
        cpf: '',
        rg: '',
        cellPhone: '',
        email: '',
        kinship: '',
        password: '',
    });

    const { id_student } = useParams()

    useEffect(() => {
        let cancelled = false;

        (async () => {
            setLoading(true);

            const idSchool = sessionStorage.getItem("id-school");
            const parsedId = JSON.parse(idSchool);

            if (!idSchool || !id_student) {
                console.error("Dados faltando: idSchool ou id_student");
                setLoading(false);
                return;
            }

            const $assessmentFormat = sessionStorage.getItem('assessmentFormat')
            setassessmentFormat($assessmentFormat)

            const positionAtEducationDepartment = localStorage.getItem("positionAtEducationDepartment")
            setPositionAtEducationDepartment(positionAtEducationDepartment)

            const position = localStorage.getItem('position_at_school');
            setPositionAtSchool(position);

            sessionStorage.setItem("StudentInformation", id_student)

            // ── FASE 1 (crítico) — regime, ano e aluno em paralelo ──
            const [response, schoolYear, res] = await Promise.all([
                getAssessmentRegime(parsedId),
                getSchoolYear(parsedId),
                StdtInfo(id_student),
            ]);

            if (cancelled) return;

            if (response?.data?.data) {
                setAssessmentRegime(response.data.data)
                sessionStorage.setItem('assessmentRegime', response.data.data);
            }

            if (res && res.data) {
                setStudent(res.data.data);
            } else {
                console.error("Resposta inesperada da API:", res);
            }

            const clss = res.data.data.find(res => {
                return res
            }).id_class.map(res => {
                if (res.year === JSON.stringify(schoolYear.data.data)) {
                    return (res)
                } else {
                    return null
                }
            }).filter(res => {
                if (!null) {
                    return (res)
                } else {
                    return null
                }
            })
            setClss(clss)

            // classRegentTeacher vem populado ({ _id, name }) — guarda só o _id
            const regent = clss
                .flatMap(res => res?.classRegentTeacher || [])
                .map(t => (t && typeof t === 'object') ? t._id : t)
                .filter(Boolean)
            if (regent.length > 0) {
                sessionStorage.setItem("RegentTeacher", regent[0])
                setRegent(true)
            } else {
                sessionStorage.removeItem("RegentTeacher")
            }

            // ── FASE 2 — os 6 períodos TODOS EM PARALELO ──
            // (antes eram 6 awaits em série → ~6x mais lento)
            const [
                IstQuarter,
                IIndQuarter,
                IIIrdQuarter,
                IVthQuarter,
                VthQuarter,
                VIthQuarter
            ] = await Promise.all([
                getIstQuarter(schoolYear.data.data, parsedId),
                getIIndQuarter(schoolYear.data.data, parsedId),
                getIIIrdQuarter(schoolYear.data.data, parsedId),
                getIVthQuarter(schoolYear.data.data, parsedId),
                getVthQuarter(schoolYear.data.data, parsedId),
                getVIthQuarter(schoolYear.data.data, parsedId),
            ]);

            if (cancelled) return;

            const i = IstQuarter.data.data.find(res => res) || null;
            const ii = IIndQuarter.data.data.find(res => res) || null;
            const iii = IIIrdQuarter.data.data.find(res => res) || null;
            const iv = IVthQuarter.data.data.find(res => res) || null;
            const v = VthQuarter.data.data.find(res => res) || null;
            const vi = VIthQuarter.data.data.find(res => res) || null;

            setbimonthly([i, ii, iii, iv, v, vi].filter(res => res !== null));

            if (i !== null) setI(i._id);
            if (ii !== null) setII(ii._id);
            if (iii !== null) setIII(iii._id);
            if (iv !== null) setIV(iv._id);
            if (v !== null) setV(v._id);
            if (vi !== null) setVI(vi._id);

            setLoading(false);

            // matérias + professor de ed. física (não bloqueiam a tela)
            const resMatter = await GetMatter(parsedId);
            if (cancelled) return;

            const filterMatter = resMatter.data.data.filter(res => {
                return res
            })

            const physical = clss
                .flatMap(res => res?.physicalEducationTeacher || [])
                .map(t => (t && typeof t === 'object') ? t._id : t)
                .filter(Boolean)
            if (physical.length > 0) {
                sessionStorage.setItem("PhysicalEducationTeacher", physical[0])
            } else {
                sessionStorage.removeItem("PhysicalEducationTeacher")
            }
            setMatter(filterMatter);
            set$schoolYea(schoolYear.data.data);
        })()

        return () => { cancelled = true; };
    }, [id_student])

    if (student) {
        const stdt = student.map(res => {
            return res.name
        })
        sessionStorage.setItem("stdt-name", stdt)
    }

    const Edit = async () => {
        navigate('/edit-student')
    }

    const signClick = async () => {
        setLoading(true);

        const studentClass = Clss.find(res => res);

        if (!studentClass?._id) {
            setLoading(false);
            alert(
                'Não foi possível gerar o boletim.\n\n' +
                'O aluno não está vinculado a nenhuma turma atualmente. ' +
                'Caso ele tenha sido transferido, retorne-o temporariamente para a turma de origem, gere o boletim e depois realize a transferência novamente.'
            );
            return;
        }

        const idClass = await Clss.find(res => res)._id

        if (!idClass) {
            alert('Este aluno não esta em uma truma se tiver sido transferido retorneo a turma para fazer a impressão do boletim e logo apos transfira novamente')
        }

        if (Selectbimonthly === I) {
            sessionStorage.setItem("id-I", I)
            if (assessmentFormat === "grade") {
                navigate(`/ist-numerical-grade-card/${idClass}`)
            } else {
                navigate(`/ist-quarter-report-card/${idClass}`)
            }
        } else if (Selectbimonthly === II) {
            sessionStorage.setItem("id-II", II)
            if (assessmentFormat === "grade") {
                navigate(`/iind-numerical-grade-card/${idClass}`)
            } else {
                navigate(`/iind-quarter-report-card/${idClass}`)
            }
        } else if (Selectbimonthly === III) {
            sessionStorage.setItem("id-III", III)
            if (assessmentFormat === "grade") {
                navigate(`/iiird-numerical-grade-card/${idClass}`)
            } else {
                navigate(`/iiird-quarter-report-card/${idClass}`)
            }
        } else if (Selectbimonthly === IV) {
            sessionStorage.setItem("id-IV", IV)
            if (assessmentFormat === "grade") {
                navigate(`/ivth-numerical-grade-card/${idClass}`)
            } else {
                navigate(`/ivth-quarter-report-card/${idClass}`)
            }
        } else if (Selectbimonthly === V) {
            sessionStorage.setItem("id-V", V)
            navigate('/vth-quarter-report-card')
        } else if (Selectbimonthly === VI) {
            sessionStorage.setItem("id-VI", VI)
            navigate(`/vith-quarter-report-card/${idClass}`)
        } else if (Selectbimonthly === 'FinalConcepts') {
            if (assessmentFormat === "grade") {
                navigate(`/final-numerical-grade-card/${idClass}`)
            } else {
                navigate(`/final-concepts-report-card/${idClass}`)
            }
        } else {
            setErrorMessage('Erro, Verifique os dados e tente novamente.');
        }
        setLoading(false);
    };

    const signClickIndForm = async () => {
        setLoading(true);
        let bim = ""; // declara fora

        if (selectedBimName === "1º BIMESTRE") {
            bim = "id_iStQuarter";
        }
        if (selectedBimName === "2º BIMESTRE") {
            bim = "id_iiNdQuarter";
        }
        if (selectedBimName === "3º BIMESTRE") {
            bim = "id_iiiRdQuarter";
        }
        if (selectedBimName === "4º BIMESTRE") {
            bim = "id_ivThQuarter";
        }
        if (selectedBimName === "Resultado Final") {
            bim = "id_finalConcepts";
        }
        const idStdt = id_student
        const idBim = selectedBimId
        if (bim) {
            navigate(`/indform/${idStdt}/${bim}/${idBim}`)
        } else {
            setErrorMessage('Erro, Verifique os dados e tente novamente.');
        }
        setLoading(false);
    };

    const ReturnHistoryGrade = async () => {
        // 🚨 NENHUM PERÍODO SELECIONADO
        if (!SelectbihistoricGrades?._id || !SelectbihistoricGrades?.bim) {
            setOpenNoPeriodModal(true);
            return;
        }

        setLoading(true);

        // 🚨 NÃO EXISTE TURMA
        if (!Clss || Clss.length === 0) {
            setLoading(false);
            setOpenNoClassModal(true);
            return; // ⛔ interrompe tudo aqui
        }

        const bimonthly = SelectbihistoricGrades.bim
        const id_class = await Clss.find(res => res)._id
        const $class = await (await clssInfo(id_class)).data.data
        const dailyStatus = $class
            .map(res => res.dailyStatus[bimonthly].regentTeacher)
            .find(Boolean); // pega o valor válido

        setopen(dailyStatus);
        const resGrades = await GetNumGrade(
            $schoolYea,
            bimonthly,
            id_student
        );
        if (resGrades.data.data) {
            const resHistoricGrades = resGrades.data.data
                .filter(res => res.idActivity == null && res.studentGrade != null)
                .map(res => res);
            setresHistoricGrade(resHistoricGrades)
            setOpenHistoricModal(true); // 👈 ABRE A JANELA
        } else {
            setErrorMessageHistoric('Erro, Verifique os dados e tente novamente.');
        }
        setLoading(false);
    };

    const signClickHistoryGrade = async () => {
        setLoading(true);

        let bim = ""; // declara fora

        if (SelectbihistoricGrades.bim === "1º BIMESTRE") {
            bim = "id_iStQuarter";
        }
        if (SelectbihistoricGrades.bim === "2º BIMESTRE") {
            bim = "id_iiNdQuarter";
        }
        if (SelectbihistoricGrades.bim === "3º BIMESTRE") {
            bim = "id_iiiRdQuarter";
        }
        if (SelectbihistoricGrades.bim === "4º BIMESTRE") {
            bim = "id_ivThQuarter";
        }
        if (SelectbihistoricGrades.bim === "Resultado Final") {
            bim = "id_finalConcepts";
        }
        const idStdt = id_student
        const idBim = SelectbihistoricGrades._id
        let id_teacher = ''
        if (Selectmatter.name === 'EDUCAÇÃO FÍSICA') {
            id_teacher = sessionStorage.getItem("PhysicalEducationTeacher")
        } else {
            id_teacher = sessionStorage.getItem("RegentTeacher")
        }
        const bimonthly = SelectbihistoricGrades.bim
        const id_matter = Selectmatter._id
        const id_class = Clss.find(res => res)._id

        // 🔒 VALIDAÇÕES
        if (!Selectmatter || !Selectmatter._id) {
            alert('Selecione a matéria.');
            setLoading(false);
            return;
        }

        if (historicGrade === null || historicGrade === undefined || historicGrade === '') {
            alert('Informe a nota do aluno.');
            setLoading(false);
            return;
        }

        if (bim && $schoolYea && historicGrade) {
            try {
                await createHistoryGrade({
                    year: $schoolYea,
                    bimonthly,
                    studentGrade: historicGrade,
                    id_teacher,
                    id_student: idStdt,
                    id_matter,
                    id_class,
                    [bim]: idBim
                })
                // ✅ RECARREGA AS NOTAS DO ALUNO
                await ReturnHistoryGrade();
            } catch (error) {
                if (error.response?.status === 400) {
                    alert(error.response.data.message);
                } else {
                    alert('Erro inesperado ao registrar a nota.');
                }
            }
        } else {
            setErrorMessageHistoric('Erro, Verifique os dados e tente novamente.');
        }
        setOpenAddHistoric(false)
        setSelectMatter([])
        setHistoricGrade([])
        setLoading(false);
    };

    const handleDeleteClick = (grade) => {
        setSelectedGrade(grade);
        setConfirmModal(true);
    };

    const handleConfirm = async () => {
        if (selectedGrade) {
            await DestroyNumericalGrade(selectedGrade._id);
            // ✅ RECARREGA AS NOTAS DO ALUNO
            await ReturnHistoryGrade();
        }
        setConfirmModal(false);
        setSelectedGrade(null);
    };

    const handleCancel = () => {
        setConfirmModal(false);
    };

    const startEditing = (grade) => {
        setUpdateStudentGrade(grade.studentGrade);
        setUpdateIdGrade(grade._id);
        // 👇 FECHA O MODAL QUE ESTÁ COBRINDO A TELA
        setOpenHistoricModal(false);
    };

    const saveEdit = async () => {
        try {
            const editedGrade = parseFloat(
                update_studentGrade.toString().replace(',', '.')
            );

            await updateNumericalGrade(update_id_grade, editedGrade);

            // recarrega as notas
            await ReturnHistoryGrade();

            setUpdateIdGrade(null);
        } catch (error) {
            alert('Erro ao atualizar a nota.');
        }
    };

    const upStatus = async () => {
        if (!selectedStatus.value) {
            alert("Por favor, selecione um status antes de salvar.");
            return; // Sai da função, não continua
        }
        setLoading(true)
        try {
            const { data } = await updateStatus({
                id_student: selectedStatus.id_student,
                status: selectedStatus.value,
                exitDate: exitDate || null,
            });

            console.log("Status atualizado com sucesso!", data);

            window.location.reload()
        } catch (error) {
            console.error("Erro ao atualizar status:", error.response?.data || error.message);
            alert(error.response?.data?.message || error.response?.data?.msg || 'Não foi possível atualizar a situação do aluno.');
            setLoading(false);
        }
    };

    const handleChangeStatus = (id, value) => {
        setSelectedStatus({ id_student: id, value: value });
    };

    const handleRespChange = (field, value) => {
        setRespForm(prev => ({ ...prev, [field]: value }));

        if (field === 'cpf') {
            checkCpf(value);
        }
    };

    // verifica o CPF a cada dígito (apenas dígitos contam)
    const checkCpf = async (rawCpf) => {
        const digits = (rawCpf || '').replace(/\D/g, '');

        setExistingResp(null);
        setRespAlreadyLinked(false);

        // só consulta a partir de 3 dígitos (abaixo nunca casa um CPF).
        // Para consultar desde o 1º dígito, troque "< 3" por "< 1".
        if (digits.length < 3) {
            setCpfChecking(false);
            return;
        }

        const reqId = ++cpfReqId.current;
        setCpfChecking(true);

        try {
            const res = await findResponsibleByCpf(digits, id_student);
            if (reqId !== cpfReqId.current) return;   // descarta resposta obsoleta

            if (res?.data?.exists && res.data.data) {
                setExistingResp(res.data.data);
                setRespAlreadyLinked(!!res.data.alreadyLinked);
                setOpenRespExistModal(true);
            } else {
                setExistingResp(null);
                setRespAlreadyLinked(false);
            }
        } catch (err) {
            if (reqId !== cpfReqId.current) return;
            setExistingResp(null);
        } finally {
            if (reqId === cpfReqId.current) setCpfChecking(false);
        }
    };

    const handleLinkExisting = async () => {
        if (!existingResp?._id) return;

        setLinkingResp(true);
        try {
            await linkResponsibleToStudent(existingResp._id, id_student);
            setOpenRespExistModal(false);
            setOpenRespModal(false);
            resetRespForm();
            setOpenRespListModal(true);
            await loadResponsibles();
            alert('Responsável vinculado ao aluno com sucesso!');
        } catch (err) {
            alert(
                err?.response?.data?.error || 'Erro ao vincular responsável. Tente novamente.'
            );
        } finally {
            setLinkingResp(false);
        }
    };

    const loadResponsibles = async () => {
        setLoadingRespList(true);
        try {
            const res = await getResponsiblesByStudent(id_student);
            setRespList(res?.data?.data || []);
        } catch (err) {
            setRespList([]);
        } finally {
            setLoadingRespList(false);
        }
    };

    const handleOpenRespList = async () => {
        setOpenRespListModal(true);
        await loadResponsibles();
    };

    const handleOpenRespCreate = () => {
        setOpenRespListModal(false);
        setOpenRespModal(true);
    };

    const handleOpenRespEdit = (resp) => {
        setEditingRespId(resp._id);
        setRespEditForm({
            name: resp.name || '',
            cpf: resp.cpf || '',
            rg: resp.rg || '',
            cellPhone: resp.cellPhone || '',
            email: resp.email || '',
            kinship: resp.kinship || '',
            password: '',
        });
        setRespEditError('');
        setOpenRespListModal(false);
        setOpenRespEditModal(true);
    };

    const handleRespEditChange = (field, value) => {
        setRespEditForm(prev => ({ ...prev, [field]: value }));
    };

    const closeRespEdit = (backToList = true) => {
        setOpenRespEditModal(false);
        setEditingRespId(null);
        setRespEditError('');
        setRespEditForm({ name: '', cpf: '', rg: '', cellPhone: '', email: '', kinship: '', password: '' });
        if (backToList) setOpenRespListModal(true);
    };

    const handleSaveRespEdit = async () => {
        const name = (respEditForm.name || '').trim();
        const cpf = (respEditForm.cpf || '').trim();

        if (!name || !cpf) {
            setRespEditError('Nome e CPF são obrigatórios.');
            return;
        }

        setSavingRespEdit(true);
        setRespEditError('');

        try {
            await updateResponsible(editingRespId, {
                name,
                cpf,
                rg: (respEditForm.rg || '').trim(),
                cellPhone: (respEditForm.cellPhone || '').trim(),
                email: (respEditForm.email || '').trim(),
                kinship: (respEditForm.kinship || '').trim(),
                password: respEditForm.password,   // backend só atualiza se preenchida
            });

            closeRespEdit(true);
            await loadResponsibles();
            alert('Responsável atualizado com sucesso!');
        } catch (err) {
            setRespEditError(
                err?.response?.data?.error || 'Erro ao atualizar responsável. Tente novamente.'
            );
        } finally {
            setSavingRespEdit(false);
        }
    };

    const resetRespForm = () => {
        setRespForm({ name: '', cpf: '', rg: '', cellPhone: '', email: '', kinship: '', password: '' });
        setRespError('');
        setExistingResp(null);
        setRespAlreadyLinked(false);
        setOpenRespExistModal(false);
        setCpfChecking(false);
    };

    const handleSaveResponsible = async () => {
        const name = (respForm.name || '').trim();
        const cpf = (respForm.cpf || '').trim();

        if (!name || !cpf) {
            setRespError('Nome e CPF são obrigatórios.');
            return;
        }

        setSavingResp(true);
        setRespError('');

        try {
            await createResponsible({
                name,
                cpf,
                rg: (respForm.rg || '').trim(),
                cellPhone: (respForm.cellPhone || '').trim(),
                email: (respForm.email || '').trim(),
                kinship: (respForm.kinship || '').trim(),
                password: respForm.password,
                id_student,
            });

            resetRespForm();
            setOpenRespModal(false);
            setOpenRespListModal(true);
            await loadResponsibles();
            alert('Responsável cadastrado e vinculado ao aluno com sucesso!');
        } catch (err) {
            setRespError(
                err?.response?.data?.error || 'Erro ao cadastrar responsável. Tente novamente.'
            );
        } finally {
            setSavingResp(false);
        }
    };

    const handleOpenHistory = async () => {
        const studentName = await student.map(student => (student.name))
        if (assessmentFormat === "grade") {
            navigate(`/history/${id_student}/${studentName}`)
        } else {
            alert("Disponível em breve")
        }
    }

    const handleOpenAnnualForm = async () => {
        if (assessmentFormat === "grade") {
            navigate(`/annual-form/${id_student}`)
        } else {
            alert("Disponível em breve")
        }
    }

    const periodText = SelectbihistoricGrades?.bim
        ? (assessmentRegime === "TRIMESTRAL"
            ? SelectbihistoricGrades.bim.replace("BIMESTRE", "TRIMESTRE")
            : SelectbihistoricGrades.bim)
        : "";

    const canManage = positionAtSchool === "DIRETOR/SUPERVISOR" || positionAtSchool === "SECRETARIO";
    const canSeeTopActions = positionAtEducationDepartment || canManage;

    // ── SKELETON ──
    if (loading) {
        return (
            <Container>
                <ContainerDivs>
                    <SkeletonHero />
                    {[1, 2].map((i) => (
                        <SkeletonCard key={i}>
                            <SkeletonLine $w="30%" $h="16px" />
                            <SkeletonLine $w="75%" />
                            <SkeletonLine $w="55%" />
                        </SkeletonCard>
                    ))}
                </ContainerDivs>
            </Container>
        );
    }

    return (
        <Container>
            {removeStudent === false &&
                <ContainerDivs>
                    {/* ── HERO: perfil do aluno ── */}
                    {student.map(stu => {
                        const exitTone = stu.status === "concluido" ? "blue" : "red";
                        const exitLabel = stu.status === "concluido" ? "Conclusão" : "Saída";
                        return (
                            <Emp key={stu._id}>
                                <EmployeeInfo>
                                    {canSeeTopActions &&
                                        <DivTopActions>
                                            <p onClick={handleOpenHistory}>📚 Histórico Escolar</p>
                                            <p onClick={handleOpenAnnualForm}>📋 Ficha Individual</p>
                                            <p onClick={() => navigate(`/occurrences/student/${id_student}`)}>📝 Ocorrências</p>
                                            {canManage &&
                                                <p onClick={handleOpenRespList}>👥 Responsáveis</p>
                                            }
                                        </DivTopActions>
                                    }
                                    <Pro>
                                        <ProfilePhoto>{initials(stu.name)}</ProfilePhoto>
                                        <ProfileInfo>
                                            <EmpName>{stu.name}</EmpName>
                                            <Span style={{ opacity: 0.85, fontWeight: 600 }}>
                                                🏫 {stu.id_school?.name}
                                            </Span>
                                        </ProfileInfo>
                                    </Pro>

                                    <DetailGrid>
                                        <DetailItem><span className="k">Nascimento</span><span className="v">{fmtDate(stu.dateOfBirth) || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">Sexo</span><span className="v">{stu.sex || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">CPF</span><span className="v">{stu.cpf || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">RG</span><span className="v">{stu.rg || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">Cor</span><span className="v">{stu.race || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">Matrícula</span><span className="v">{stu.Registration || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">Nome da Mãe</span><span className="v">{stu.motherName || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">Celular da Mãe</span><span className="v">{stu.motherCellPhone || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">Nome do Pai</span><span className="v">{stu.fatherName || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">Celular do Pai</span><span className="v">{stu.fatherCellPhone || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">Endereço</span><span className="v">{stu.address || '—'}</span></DetailItem>
                                        <DetailItem><span className="k">RS</span><span className="v">{stu.registerStudent || '—'}</span></DetailItem>
                                    </DetailGrid>

                                    <SchoolDivider />

                                    <DetailGrid>
                                        {stu.admissionDate && (
                                            <DetailItem><span className="k">Data de Admissão</span><span className="v">{fmtDate(stu.admissionDate)}</span></DetailItem>
                                        )}
                                        <DetailItem $tone="green"><span className="k">Ingresso na Escola</span><span className="v">{fmtDate(stu.entryDate) || '—'}</span></DetailItem>
                                        {stu.departureDate && (
                                            <DetailItem $tone={exitTone}>
                                                <span className="k">Data de {exitLabel}</span>
                                                <span className="v">{fmtDate(stu.departureDate)}</span>
                                            </DetailItem>
                                        )}
                                    </DetailGrid>

                                    {canManage || positionAtEducationDepartment ? (
                                        <DivButtomEdit>
                                            <Btt02 onClick={Edit}>✏️ Editar</Btt02>
                                        </DivButtomEdit>
                                    ) : null}
                                </EmployeeInfo>
                            </Emp>
                        );
                    })}

                    {/* ── Turma(s) ── */}
                    {Clss && Clss.length > 0 &&
                        Clss.map(clss => (
                            <Emp key={clss._id} $plain>
                                <ClassTitle><span>🏷️</span> Turma</ClassTitle>
                                <ClassChips>
                                    <span>Série: {clss.serie}</span>
                                    <span>Turma: {clss.name}</span>
                                    <span>Turno: {clss.shift}</span>
                                    <span>Ano: {clss.year}</span>
                                </ClassChips>
                            </Emp>
                        ))
                    }

                    {/* ── Calendário ── */}
                    {/*Regent &&
                        <ContainerCalendar>
                            <Calendar />
                        </ContainerCalendar>
                    */}

                    {/* ── Desempenho do aluno ── */}
                    <PerformanceSection
                        studentId={id_student}
                        format={assessmentFormat}
                        idSchool={student[0]?.id_school?._id}
                    />

                    {/* ── Boletim ── */}
                    <SectionLabel>Documentos</SectionLabel>
                    <Input>
                        <h3>📄 Boletim</h3>
                        <Label>Selecione o período e clique no botão abaixo.</Label>
                        <Select
                            id="id-bimonthly"
                            value={Selectbimonthly}
                            onChange={(e) => setSelectbimonthly(e.target.value)}
                        >
                            <option value="">Selecione</option>
                            {bimonthly
                                .filter(res => {
                                    if (assessmentRegime !== 'TRIMESTRAL') return true
                                    return !res.bimonthly.includes('4º')
                                })
                                .map(res => (
                                    <option key={res._id} value={res._id}>
                                        {assessmentRegime === 'TRIMESTRAL'
                                            ? res.bimonthly.replace('BIMESTRE', 'TRIMESTRE')
                                            : res.bimonthly}
                                    </option>
                                ))
                            }
                            <option value="FinalConcepts">Resultado Final</option>
                        </Select>
                        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                        <Button onClick={signClick}>Ver boletim</Button>
                    </Input>

                    {/* ── Relatório individual (conceito) ── */}
                    {assessmentFormat === "concept" &&
                        <Input>
                            <h3>📝 Relatório Individual</h3>
                            <Label>Selecione o período e clique no botão abaixo.</Label>
                            <Select
                                value={selectedBimId}
                                onChange={(e) => {
                                    const id = e.target.value;
                                    setSelectedBimId(id);

                                    const selectedOption = bimonthly.find(res => res._id === id);

                                    if (selectedOption) setSelectedBimName(selectedOption.bimonthly);
                                    else setSelectedBimName("");
                                }}
                            >
                                <option value="">Selecione</option>
                                {bimonthly
                                    .filter(res => {
                                        if (assessmentRegime !== 'TRIMESTRAL') return true
                                        return !res.bimonthly.includes('4º')
                                    })
                                    .map(res => (
                                        <option key={res._id} value={res._id}>
                                            {assessmentRegime === 'TRIMESTRAL'
                                                ? res.bimonthly.replace('BIMESTRE', 'TRIMESTRE')
                                                : res.bimonthly}
                                        </option>
                                    ))
                                }
                            </Select>
                            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                            <Button onClick={signClickIndForm}>Ver Relatório</Button>
                        </Input>
                    }

                    {/* ── Notas de outras escolas ── */}
                    {(assessmentFormat === "grade" && canManage) &&
                        <HistoricGradeContainer>
                            <Input>
                                <h3>🏫 Notas provenientes de outras escolas</h3>
                                <Label>Selecione o período e clique no botão abaixo.</Label>
                                <Select
                                    id="id-bimonthly"
                                    value={SelectbihistoricGrades?._id || ""}
                                    onChange={(e) => {
                                        const selected = bimonthly.find(b => b._id === e.target.value)
                                        setSelectbihistoricGrades({
                                            _id: selected._id,
                                            bim: selected.bimonthly
                                        })
                                    }}
                                >
                                    <option value="">Selecione</option>
                                    {bimonthly
                                        .filter(res => {
                                            if (assessmentRegime !== 'TRIMESTRAL') return true
                                            return !res.bimonthly.includes('4º')
                                        })
                                        .map(res => (
                                            <option key={res._id} value={res._id}>
                                                {assessmentRegime === 'TRIMESTRAL'
                                                    ? res.bimonthly.replace('BIMESTRE', 'TRIMESTRE')
                                                    : res.bimonthly}
                                            </option>
                                        ))
                                    }
                                </Select>
                                <Button onClick={ReturnHistoryGrade}>Ver notas de outras escolas</Button>
                            </Input>
                        </HistoricGradeContainer>
                    }

                    {/* ── Modal: notas de outras escolas ── */}
                    {openHistoricModal && (
                        <HistoricModalOverlay onClick={() => setOpenHistoricModal(false)}>
                            <HistoricModalContent onClick={(e) => e.stopPropagation()}>
                                <h3>🏫 Notas provenientes de outras escolas</h3>

                                <HeaderRow>
                                    <h4>{periodText}</h4>
                                    <AddHistoricButton
                                        onClick={() => {
                                            if (open !== 'aberto') {
                                                alert('Este periodo está fechado. Não é possível registrar notas.');
                                                return;
                                            }
                                            setOpenAddHistoric(true);
                                        }}
                                    >
                                        ＋ Registrar nota
                                    </AddHistoricButton>
                                </HeaderRow>

                                {resHistoricGrade.length === 0 ? (
                                    <EmptyHistoricMessage>
                                        Não há nenhuma nota proveniente de outras escolas para este período.
                                    </EmptyHistoricMessage>
                                ) : (
                                    resHistoricGrade
                                        .slice()
                                        .sort((a, b) => (a.id_matter?.name || '').localeCompare(b.id_matter?.name || ''))
                                        .map((grade) => (
                                            <HistoricGradeRow key={grade._id}>
                                                <span>{grade.id_matter?.name}</span>
                                                <strong>{grade.studentGrade}</strong>
                                                <Btt02 onClick={() => {
                                                    if (open !== 'aberto') {
                                                        alert('O bimestre está fechado. Não é possível deletar notas.');
                                                        return;
                                                    }
                                                    handleDeleteClick(grade)
                                                }}>🗑️</Btt02>
                                                <Btt02 onClick={() => {
                                                    if (open !== 'aberto') {
                                                        alert('O bimestre está fechado. Não é possível editar notas.');
                                                        return;
                                                    }
                                                    startEditing(grade)
                                                }}>✏️</Btt02>
                                            </HistoricGradeRow>
                                        ))
                                )}

                                <Button onClick={() => setOpenHistoricModal(false)}>Fechar</Button>
                            </HistoricModalContent>
                        </HistoricModalOverlay>
                    )}

                    {/* ── Modal: nenhum período selecionado ── */}
                    {openNoPeriodModal && (
                        <ModalOverlay onClick={() => setOpenNoPeriodModal(false)}>
                            <ModalContent onClick={(e) => e.stopPropagation()}>
                                <h3>⚠️ Selecione um período</h3>
                                <p>
                                    Para ver as notas provenientes de outras escolas, selecione primeiro
                                    o {assessmentRegime === 'TRIMESTRAL' ? 'trimestre' : 'bimestre'} desejado
                                    e depois clique em "Ver notas de outras escolas".
                                </p>
                                <ModalActions>
                                    <Btt02 onClick={() => setOpenNoPeriodModal(false)}>Entendi</Btt02>
                                </ModalActions>
                            </ModalContent>
                        </ModalOverlay>
                    )}

                    {/* ── Modal: sem turma ── */}
                    {openNoClassModal && (
                        <ModalOverlay onClick={() => setOpenNoClassModal(false)}>
                            <ModalContent onClick={(e) => e.stopPropagation()}>
                                <h3>⚠️ Acesso indisponível</h3>
                                <p>
                                    Para acessar as notas provenientes de outras escolas, o aluno precisa estar
                                    vinculado a uma turma nesta escola.
                                    <br /><br />
                                    Caso o aluno tenha sido transferido para outra instituição, as notas lançadas
                                    ficam disponíveis apenas no diário da turma referente ao ano letivo em que
                                    ele esteve vinculado.
                                </p>
                                <ModalActions>
                                    <Btt02 onClick={() => setOpenNoClassModal(false)}>Entendi</Btt02>
                                </ModalActions>
                            </ModalContent>
                        </ModalOverlay>
                    )}

                    {/* ── Modal: confirmar exclusão de nota ── */}
                    {confirmModal && (
                        <BlurBackground onClick={handleCancel}>
                            <ModalContainer onClick={(e) => e.stopPropagation()}>
                                <h3>Tem certeza que deseja deletar a nota?</h3>
                                <div>
                                    <button
                                        style={{ background: '#cf3a3a', color: 'white', border: 'none' }}
                                        onClick={handleConfirm}
                                    >Sim</button>
                                    <button onClick={handleCancel}>Não</button>
                                </div>
                            </ModalContainer>
                        </BlurBackground>
                    )}

                    {/* ── Overlay: editar nota ── */}
                    {update_id_grade && (
                        <EditOverlay onClick={() => { setUpdateIdGrade(null); setOpenHistoricModal(true); }}>
                            <EditContainer onClick={(e) => e.stopPropagation()}>
                                <h3>✏️ Editando Nota</h3>
                                <EmpEdit>
                                    <Grade id='nota'>
                                        <div className='nota'>
                                            <p>Nota:</p>
                                            <input
                                                placeholder="N/A"
                                                value={update_studentGrade}
                                                onChange={(e) => setUpdateStudentGrade(e.target.value)}
                                            />
                                        </div>
                                    </Grade>
                                </EmpEdit>
                                {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                                <ModalActions>
                                    <ButtonSecondary onClick={() => {
                                        setUpdateIdGrade(null)
                                        setOpenHistoricModal(true);
                                    }}>Cancelar</ButtonSecondary>
                                    <Btt02 onClick={saveEdit}>Salvar</Btt02>
                                </ModalActions>
                            </EditContainer>
                        </EditOverlay>
                    )}

                    {/* ── Modal: registrar nota de outra escola ── */}
                    {openAddHistoric && (
                        <HistoricModalOverlay onClick={() => setOpenAddHistoric(false)}>
                            <HistoricModalContent onClick={(e) => e.stopPropagation()}>
                                <h3>＋ Registrar nota proveniente de outras escolas</h3>

                                <Label>Selecione a Disciplina</Label>
                                <Select
                                    id="id-matter"
                                    value={Selectmatter?._id || ""}
                                    onChange={(e) => {
                                        const selected = matter.find(m => m._id === e.target.value);
                                        setSelectMatter({
                                            _id: selected._id,
                                            name: selected.name
                                        });
                                    }}
                                >
                                    <option value="">Selecione</option>
                                    {matter.map(res => (
                                        <option key={res._id} value={res._id}>{res.name}</option>
                                    ))}
                                </Select>

                                <Label>Nota do aluno</Label>
                                <input
                                    type="number"
                                    placeholder="Ex: 17,5"
                                    min="0"
                                    step="0.1"
                                    value={historicGrade}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {
                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(',', '.');
                                        if (value === '') {
                                            setHistoricGrade('');
                                            return;
                                        }
                                        const numericValue = Number(value);
                                        if (isNaN(numericValue) || numericValue < 0) return;
                                        setHistoricGrade(value);
                                    }}
                                />

                                {errorMessageHistoric && <ErrorMessage>{errorMessageHistoric}</ErrorMessage>}

                                <ModalActions>
                                    <ButtonSecondary onClick={() => setOpenAddHistoric(false)}>Cancelar</ButtonSecondary>
                                    <Button onClick={signClickHistoryGrade}>Registrar</Button>
                                </ModalActions>
                            </HistoricModalContent>
                        </HistoricModalOverlay>
                    )}

                    {/* ── Modal: lista de responsáveis ── */}
                    {openRespListModal && (
                        <ModalOverlay onClick={() => setOpenRespListModal(false)}>
                            <ModalContent onClick={(e) => e.stopPropagation()}>
                                <HeaderRow>
                                    <h3>👥 Responsáveis</h3>
                                    <AddHistoricButton onClick={handleOpenRespCreate}>
                                        ＋ Adicionar Responsável
                                    </AddHistoricButton>
                                </HeaderRow>

                                <Label style={{ textAlign: 'center', marginBottom: 4 }}>
                                    Responsáveis vinculados a <strong>{sessionStorage.getItem('stdt-name')}</strong>.
                                </Label>

                                {loadingRespList ? (
                                    <RespList>
                                        {[1, 2].map(i => (
                                            <SkeletonCard key={i}>
                                                <SkeletonLine $w="40%" $h="15px" />
                                                <SkeletonLine $w="65%" />
                                            </SkeletonCard>
                                        ))}
                                    </RespList>
                                ) : respList.length === 0 ? (
                                    <EmptyHistoricMessage>
                                        Nenhum responsável cadastrado para este aluno.
                                    </EmptyHistoricMessage>
                                ) : (
                                    <RespList>
                                        {respList.map(resp => (
                                            <RespCard key={resp._id}>
                                                <RespCardHead>
                                                    <RespAvatar>{initials(resp.name)}</RespAvatar>
                                                    <div className="resp-id">
                                                        <strong>{resp.name}</strong>
                                                        {resp.kinship && <span className="kin">{resp.kinship}</span>}
                                                    </div>
                                                    <RespEditBtn
                                                        onClick={() => handleOpenRespEdit(resp)}
                                                        title="Editar responsável"
                                                    >
                                                        ✏️ Editar
                                                    </RespEditBtn>
                                                </RespCardHead>

                                                <RespCardBody>
                                                    <RespDataPill>
                                                        <span className="icon">🪪</span>
                                                        <span className="data">
                                                            <span className="k">CPF</span>
                                                            <span className="v">{resp.cpf || '—'}</span>
                                                        </span>
                                                    </RespDataPill>
                                                    <RespDataPill>
                                                        <span className="icon">📱</span>
                                                        <span className="data">
                                                            <span className="k">Celular</span>
                                                            <span className="v">{resp.cellPhone || '—'}</span>
                                                        </span>
                                                    </RespDataPill>
                                                    <RespDataPill>
                                                        <span className="icon">📧</span>
                                                        <span className="data">
                                                            <span className="k">E-mail</span>
                                                            <span className="v">{resp.email || '—'}</span>
                                                        </span>
                                                    </RespDataPill>
                                                    <RespDataPill>
                                                        <span className="icon">📄</span>
                                                        <span className="data">
                                                            <span className="k">RG</span>
                                                            <span className="v">{resp.rg || '—'}</span>
                                                        </span>
                                                    </RespDataPill>
                                                </RespCardBody>
                                            </RespCard>
                                        ))}
                                    </RespList>
                                )}

                                <ModalActions>
                                    <Btt02 onClick={() => setOpenRespListModal(false)}>Fechar</Btt02>
                                </ModalActions>
                            </ModalContent>
                        </ModalOverlay>
                    )}

                    {/* ── Modal: cadastrar responsável ── */}
                    {openRespModal && (
                        <ModalOverlay onClick={() => { setOpenRespModal(false); resetRespForm(); }}>
                            <ModalContent onClick={(e) => e.stopPropagation()}>
                                <h3>👥 Cadastrar Responsável</h3>
                                <Label style={{ textAlign: 'center', marginBottom: 4 }}>
                                    O responsável será vinculado a <strong>{sessionStorage.getItem('stdt-name')}</strong>.
                                </Label>

                                <RespForm>

                                    <RespFormRow>
                                        <Label>CPF *</Label>
                                        <input
                                            type="text"
                                            placeholder="000.000.000-00"
                                            value={respForm.cpf}
                                            onChange={(e) => handleRespChange('cpf', e.target.value)}
                                        />
                                        {cpfChecking && <CpfStatus $tone="checking">Verificando CPF…</CpfStatus>}
                                        {!cpfChecking && existingResp && (
                                            <CpfStatus $tone="found" onClick={() => setOpenRespExistModal(true)}>
                                                Já existe um responsável com este CPF — clique para ver
                                            </CpfStatus>
                                        )}
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>Nome completo *</Label>
                                        <input
                                            type="text"
                                            placeholder="Nome do responsável"
                                            value={respForm.name}
                                            onChange={(e) => handleRespChange('name', e.target.value)}
                                        />
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>RG</Label>
                                        <input
                                            type="text"
                                            placeholder="RG"
                                            value={respForm.rg}
                                            onChange={(e) => handleRespChange('rg', e.target.value)}
                                        />
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>Parentesco</Label>
                                        <Select
                                            value={respForm.kinship}
                                            onChange={(e) => handleRespChange('kinship', e.target.value)}
                                        >
                                            <option value="">Selecione</option>
                                            <option value="mãe">Mãe</option>
                                            <option value="pai">Pai</option>
                                            <option value="avó/avô">Avó/Avô</option>
                                            <option value="tio/tia">Tio/Tia</option>
                                            <option value="responsável legal">Responsável legal</option>
                                            <option value="outro">Outro</option>
                                        </Select>
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>Celular</Label>
                                        <input
                                            type="text"
                                            placeholder="(00) 00000-0000"
                                            value={respForm.cellPhone}
                                            onChange={(e) => handleRespChange('cellPhone', e.target.value)}
                                        />
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>E-mail</Label>
                                        <input
                                            type="email"
                                            placeholder="email@exemplo.com"
                                            value={respForm.email}
                                            onChange={(e) => handleRespChange('email', e.target.value)}
                                        />
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>Senha de acesso</Label>
                                        <input
                                            type="password"
                                            placeholder="Senha para o login do responsável"
                                            value={respForm.password}
                                            onChange={(e) => handleRespChange('password', e.target.value)}
                                        />
                                    </RespFormRow>
                                </RespForm>

                                {respError && <ErrorMessage>{respError}</ErrorMessage>}

                                <ModalActions>
                                    <ButtonSecondary
                                        onClick={() => { setOpenRespModal(false); resetRespForm(); setOpenRespListModal(true); }}
                                        disabled={savingResp}
                                    >
                                        Cancelar
                                    </ButtonSecondary>
                                    <Button onClick={handleSaveResponsible} disabled={savingResp}>
                                        {savingResp ? 'Salvando...' : 'Cadastrar'}
                                    </Button>
                                </ModalActions>
                            </ModalContent>
                        </ModalOverlay>
                    )}

                    {/* ── Modal: responsável já existe ── */}
                    {openRespExistModal && existingResp && (
                        <ModalOverlay onClick={() => setOpenRespExistModal(false)}>
                            <ModalContent onClick={(e) => e.stopPropagation()}>
                                <h3>👤 Responsável já cadastrado</h3>

                                {respAlreadyLinked ? (
                                    <Label style={{ textAlign: 'center', color: 'var(--green)', fontWeight: 700 }}>
                                        ✔ {existingResp.name} (CPF {existingResp.cpf}) já está vinculado a {sessionStorage.getItem('stdt-name')}.
                                    </Label>
                                ) : (
                                    <Label style={{ textAlign: 'center' }}>
                                        O responsável <strong>{existingResp.name}</strong>, CPF <strong>{existingResp.cpf}</strong>,
                                        já existe no sistema. Deseja vinculá-lo a <strong>{sessionStorage.getItem('stdt-name')}</strong>?
                                    </Label>
                                )}

                                <RespExistCard>
                                    <div className="resp-head">
                                        <ProfilePhoto>{initials(existingResp.name)}</ProfilePhoto>
                                        <div className="resp-id">
                                            <strong>{existingResp.name}</strong>
                                            {existingResp.kinship && <span className="kin">{existingResp.kinship}</span>}
                                        </div>
                                    </div>
                                    <RespExistRow><span className="k">CPF</span><span className="v">{existingResp.cpf || '—'}</span></RespExistRow>
                                    <RespExistRow><span className="k">RG</span><span className="v">{existingResp.rg || '—'}</span></RespExistRow>
                                    <RespExistRow><span className="k">Celular</span><span className="v">{existingResp.cellPhone || '—'}</span></RespExistRow>
                                    <RespExistRow><span className="k">E-mail</span><span className="v">{existingResp.email || '—'}</span></RespExistRow>
                                </RespExistCard>

                                <ModalActions>
                                    <ButtonSecondary
                                        onClick={() => setOpenRespExistModal(false)}
                                        disabled={linkingResp}
                                    >
                                        {respAlreadyLinked ? 'Fechar' : 'Cancelar'}
                                    </ButtonSecondary>
                                    {!respAlreadyLinked && (
                                        <Button onClick={handleLinkExisting} disabled={linkingResp}>
                                            {linkingResp ? 'Vinculando...' : 'Vincular ao aluno'}
                                        </Button>
                                    )}
                                </ModalActions>
                            </ModalContent>
                        </ModalOverlay>
                    )}

                    {/* ── Modal: editar responsável ── */}
                    {openRespEditModal && (
                        <ModalOverlay onClick={() => closeRespEdit(true)}>
                            <ModalContent onClick={(e) => e.stopPropagation()}>
                                <h3>✏️ Editar Responsável</h3>

                                <RespForm>
                                    <RespFormRow>
                                        <Label>Nome completo *</Label>
                                        <input
                                            type="text"
                                            placeholder="Nome do responsável"
                                            value={respEditForm.name}
                                            onChange={(e) => handleRespEditChange('name', e.target.value)}
                                        />
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>CPF *</Label>
                                        <input
                                            type="text"
                                            placeholder="000.000.000-00"
                                            value={respEditForm.cpf}
                                            onChange={(e) => handleRespEditChange('cpf', e.target.value)}
                                        />
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>RG</Label>
                                        <input
                                            type="text"
                                            placeholder="RG"
                                            value={respEditForm.rg}
                                            onChange={(e) => handleRespEditChange('rg', e.target.value)}
                                        />
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>Parentesco</Label>
                                        <Select
                                            value={respEditForm.kinship}
                                            onChange={(e) => handleRespEditChange('kinship', e.target.value)}
                                        >
                                            <option value="">Selecione</option>
                                            <option value="mãe">Mãe</option>
                                            <option value="pai">Pai</option>
                                            <option value="avó/avô">Avó/Avô</option>
                                            <option value="tio/tia">Tio/Tia</option>
                                            <option value="responsável legal">Responsável legal</option>
                                            <option value="outro">Outro</option>
                                        </Select>
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>Celular</Label>
                                        <input
                                            type="text"
                                            placeholder="(00) 00000-0000"
                                            value={respEditForm.cellPhone}
                                            onChange={(e) => handleRespEditChange('cellPhone', e.target.value)}
                                        />
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>E-mail</Label>
                                        <input
                                            type="email"
                                            placeholder="email@exemplo.com"
                                            value={respEditForm.email}
                                            onChange={(e) => handleRespEditChange('email', e.target.value)}
                                        />
                                    </RespFormRow>

                                    <RespFormRow>
                                        <Label>Nova senha (deixe em branco para manter)</Label>
                                        <input
                                            type="password"
                                            placeholder="••••••••"
                                            value={respEditForm.password}
                                            onChange={(e) => handleRespEditChange('password', e.target.value)}
                                        />
                                    </RespFormRow>

                                </RespForm>

                                {respEditError && <ErrorMessage>{respEditError}</ErrorMessage>}

                                <ModalActions>
                                    <ButtonSecondary
                                        onClick={() => closeRespEdit(true)}
                                        disabled={savingRespEdit}
                                    >
                                        Cancelar
                                    </ButtonSecondary>
                                    <Button onClick={handleSaveRespEdit} disabled={savingRespEdit}>
                                        {savingRespEdit ? 'Salvando...' : 'Salvar alterações'}
                                    </Button>
                                </ModalActions>
                            </ModalContent>
                        </ModalOverlay>
                    )}
                </ContainerDivs>
            }

            {/* ── Botão alterar status ── */}
            {canManage && removeStudent === false &&
                <ContainerDivs style={{ marginTop: 4 }}>
                    <Btt01 onClick={() => { setRemoveStudent(true) }} style={{ alignSelf: 'center' }}>
                        Alterar Status
                    </Btt01>
                </ContainerDivs>
            }

            {/* ── Modal: alterar status ── */}
            {removeStudent === true && (
                <ModalOverlay onClick={() => setRemoveStudent(false)}>
                    <ModalContent onClick={(e) => e.stopPropagation()}>
                        {student.map((stu) => (
                            <TableRow key={stu._id}>
                                <h3>Alterar Status do Aluno</h3>
                                <p style={{ textAlign: 'center', fontWeight: 600 }}>{stu.name}</p>
                                <Chip color={stu.status}>{stu.status}</Chip>
                                <Label>Novo Status:</Label>
                                <Select
                                    value={selectedStatus.status}
                                    onChange={(e) => {
                                        handleChangeStatus(stu._id, e.target.value)
                                        setExitDate(e.target.value === "transferido" || e.target.value === "inativo" || e.target.value === "concluido" ? new Date().toISOString().split('T')[0] : null);
                                    }}
                                >
                                    <option value="">Selecione</option>
                                    {stu.status !== "ativo" && <option value="ativo">Ativar</option>}
                                    {stu.status !== "transferido" && <option value="transferido">Transferir</option>}
                                    {stu.status !== "inativo" && <option value="inativo">Inativar</option>}
                                    {stu.status !== "concluido" && <option value="concluido">Concluir</option>}
                                </Select>

                                {selectedStatus.value === "transferido" && (
                                    <WarningBox>
                                        ⚠ Atenção: Ao transferir um aluno, ele será removido da turma atual.
                                        Antes de continuar, certifique-se de que todos os dados estão preenchidos
                                        corretamente e salvos.
                                    </WarningBox>
                                )}
                                {selectedStatus.value === "transferido" && (
                                    <ConsolidationWarningModal
                                        acao="transfira"
                                        onCancel={() => { setSelectedStatus({}); setRemoveStudent(false) }}
                                    />
                                )}

                                {selectedStatus.value === "concluido" && (
                                    <p style={{ color: "var(--green)", fontWeight: "bold", textAlign: 'center' }}>
                                        ✔ O aluno será marcado como concluído.
                                    </p>
                                )}

                                {(selectedStatus.value === "transferido" || selectedStatus.value === "inativo" || selectedStatus.value === "concluido") && (
                                    <div>
                                        <Label>
                                            {selectedStatus.value === "concluido" ? "Data de Conclusão:" : "Data de Saída:"}
                                        </Label>
                                        <input
                                            type="date"
                                            value={exitDate}
                                            onChange={(e) => setExitDate(e.target.value)}
                                            min="1900-01-01"
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </div>
                                )}

                                <div className='botões'>
                                    <Button onClick={() => upStatus()} style={{ background: "#1d8b5a" }}>
                                        Salvar
                                    </Button>
                                    <Button onClick={() => setRemoveStudent(false)} style={{ background: "#6b7280", boxShadow: 'none' }}>
                                        Cancelar
                                    </Button>
                                </div>
                            </TableRow>
                        ))}
                    </ModalContent>
                </ModalOverlay>
            )}
        </Container>
    )
}

export default Student